import React from 'react';
import { Section } from './ui/Section';
export function FAQ() {
  const faqs = [{
    q: '¿Es solo para instructoras avanzadas?',
    a: 'No. Funciona tanto si llevas 2 años como si llevas 15.'
  }, {
    q: '¿Puedo verlo en el móvil durante la clase?',
    a: 'Sí. PDFs optimizados para móvil, tablet y ordenador.'
  }, {
    q: '¿El pago es mensual?',
    a: 'No. Pago único. El material es tuyo para siempre.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Por correo inmediatamente después del pago.'
  }, {
    q: '¿Recibiré actualizaciones?',
    a: 'Sí. Todas las actualizaciones futuras gratis.'
  }, {
    q: '¿Qué pasa si no me convence?',
    a: '7 días de garantía. Reembolso 100% sin preguntas.'
  }];
  return <Section variant="alt" data-id="element-64">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-8 text-brand-title" data-id="element-65">
        ❓ Preguntas Frecuentes
      </h2>

      <div className="max-w-3xl mx-auto space-y-3 mb-8" data-id="element-66">
        {faqs.map((faq, i) => <div key={i} className="bg-white border border-brand-border rounded-xl p-5 shadow-card hover:shadow-card-hover transition-all" data-id="element-67">
            <h3 className="font-heading font-bold text-base text-brand-subtitle mb-2" data-id="element-68">
              {faq.q}
            </h3>
            <p className="font-body text-brand-text text-sm" data-id="element-69">{faq.a}</p>
          </div>)}
      </div>

      <div className="text-center bg-white border border-brand-borderAccent rounded-2xl p-5 max-w-2xl mx-auto shadow-card" data-id="element-70">
        <p className="font-body text-brand-text mb-2 text-sm" data-id="element-71">
          ¿Más dudas? Escríbenos
        </p>
        <p className="font-body text-brand-title font-semibold" data-id="element-72">
          📧 digipromarket3@gmail.com
        </p>
      </div>
    </Section>;
}